module.exports = __webpack_public_path__ + "img/featurefour.f58a958b.png";